// extracted by mini-css-extract-plugin
export var hideEditor = "_s8-2";
export var infoIcon = "_s8-3";
export var label = "_s8-1";
export var labelContainer = "_s8-0";
export var readonlyText = "_s8-4";